<header class="fixed-header-bar">
  <section class="container-fluid content">
    <div class="row middle-xs warningText">
      <div class="col-xs-6 col-md-8">
        <cz-site-filters [showContent]="!isDefaultUser"></cz-site-filters>
      </div>
      
      <!-- License Warning Message -->
      <div class="licence-warning-msg">
        <div  class="lic-warn-msg-inner" [innerHTML]="alert1"></div>
      </div>
      <!-- License Warning Message End -->
      
      <div class="col-xs-3 col-md-4 end-xs">
        <cz-user-name-link *ngIf="user$ | async as user" [user]="user" [config]="badgeConfig" [displayLicence]="displayLicence" class="profileText"></cz-user-name-link>
      </div>
    </div>
  </section>
  <cz-create-task-button *ngIf="canCreateTask" class="menu-more"></cz-create-task-button>
</header>
